<template>
  <div class="invoice-text-redactor">
    <app-redactor placeholder="Текста нет"
                  v-model="model"
                  @save="saveText"
                  @cancel="cancelText"
                  save-button
                  cancel-button
                  :buttons="['bold', 'italic', 'underline']"
                  min-height="180px"
                  use-variables
                  :variables="constants"
    />
  </div>
</template>

<script>
  export default {
    name: "TextRedactor",
    props: {
      value: {},
      constants: {}
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(v) {
          this.$emit('input', v);
        }
      }
    },
    methods: {
      saveText(text) {
        this.$emit('save', text);
      },
      cancelText(text) {
        this.$emit('cancel', text);
      }
    }
  }
</script>

<style lang="scss">
  .invoice-text-redactor {
    .redactor-box.redactor-styles-on {
      border: 1px solid rgba(var(--app-content-color), .3);
    }

    .redactor-air a.re-button-icon, .redactor-toolbar a.re-button-icon {
      padding: 5px 8px;
      font-size: 10px;
    }

    .redactor-air a, .redactor-toolbar a {
      padding: 5px 8px;
      font-size: 10px;
    }

    .redactor-box.redactor-styles-on .redactor-toolbar {
      padding: 10px 5px 5px;
      border-bottom: 1px solid rgba(var(--app-content-color), .3);
    }

    .redactor-styles {
      padding: 10px;
    }
  }
</style>
